/* iDU design tokens, typed for the MUI theme factory.
 * GENERATED from tokens.json by build-tokens.mjs. Do not hand-edit.
 *
 * mui-theme.ts imports these instead of hand-copying values that already exist as tokens
 * (022 FR-005a). Its component overrides stay hand-written there — a generator should own
 * values, not design decisions.
 */

export type IduBrand = 'checkd' | 'trackd' | 'dashd';

export const FONT_SANS =
  'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif';
export const FONT_MONO = 'Inconsolata, monospace';
export const FONT_DISPLAY = 'Inter, sans-serif';

export const NEUTRAL = {
  text: {
    primary: '#1F2024',
    secondary: '#5F626D',
    disabled: '#AAAEB9',
    link: '#0269A3',
  },
  divider: '#DCDCDC',
  paper: '#FFFFFF',
} as const;

export const STATUS = {
  success: {
    dark: '#105E2C',
    main: '#199144',
    light: '#82D57A',
  },
  error: {
    dark: '#860B0B',
    main: '#D32F2F',
    light: '#FFAFAF',
  },
  warning: {
    dark: '#5E4610',
    main: '#D9540C',
    light: '#FFE3A8',
  },
  info: {
    dark: '#10345E',
    main: '#0288D1',
    light: '#B6E1FF',
  },
} as const;

export const IDU_ACCENT = '#C42464';

/** Per-brand ramp plus the values 022 FR-004 requires the theme to derive rather than hardcode. */
export const BRAND = {
  checkd: {
    dark: '#8C0668',
    main: '#B73193',
    light: '#FAE9F9',
    onBrand: '#FFFFFF',
    canvas: '#FCFCFC',
    radiusBase: '4px',
    spacing: '8px',
    accent: '#E297CE',
    separator: '#E3C8DC',
  },
  trackd: {
    dark: '#31077A',
    main: '#6244BE',
    light: '#F1E9FA',
    onBrand: '#FFFFFF',
    canvas: '#F0F0F2',
    radiusBase: '4px',
    spacing: '8px',
    accent: '#B7B8FF',
    separator: '#D1C8E3',
    pressed: '#553096',
    darkest: '#24183A',
    mainHover: '#5238A6',
    rowLine: '#F0F0F2',
  },
  dashd: {
    dark: '#062C8C',
    main: '#3161D1',
    light: '#DCEBFF',
    onBrand: '#FFFFFF',
    canvas: '#FCFCFC',
    radiusBase: '4px',
    spacing: '8px',
    accent: '#A0B2D3',
    separator: '#C8D1E3',
  },
} as const;

export const RADIUS = {
  base: 4,
  capsule: 16,
  pill: 9999,
} as const;

export const TYPE = {
  display: {
    fontWeight: 900,
    fontSize: '48px',
    lineHeight: 1.05,
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '28px',
  },
  amount: {
    fontWeight: 600,
    fontSize: '36px',
    lineHeight: 1.1,
    letterSpacing: '-0.5px',
  },
  bodyLarge: {
    fontSize: '16px',
    lineHeight: '24px',
  },
  body: {
    fontSize: '14px',
    lineHeight: '20px',
  },
  caption: {
    fontSize: '12px',
    lineHeight: '16px',
  },
} as const;

export const WEIGHT = {
  regular: 400,
  medium: 500,
  semibold: 600,
  black: 900,
} as const;

export const SHADOW = {
  card: '0 1px 3px rgba(0,0,0,0.25)',
  raised: '0 4px 12px rgba(0,0,0,0.30)',
} as const;

export const CONTROL_H = {
  lg: '48px',
  md: '40px',
  sm: '32px',
  tiny: '24px',
} as const;

export const SIZE = {
  navWidth: '280px',
  desktopSurface: '1133px',
  touchMin: '44px',
  inputTouchFontMin: '16px',
} as const;

export const CHROME = {
  tabBar: '4rem',
  pageHeader: '3rem',
  taskHeader: '96px',
  taskHeaderCollapsed: '28px',
  taskSheet: '640px',
  taskSheetMaxHeight: '620px',
  rail: '72px',
  railExpanded: '240px',
} as const;
